import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './index.scss';

// PREAP-1562/PREAP-1541 allows for these to be TEI types as well
const VALID_ITEM_TYPES = [
  'mcq',
  'hotspot',
  'clozeassociation',
  'imageclozeassociation',
  'imageclozeassociationV2',
  'clozetext',
  'tokenhighlight',
  'clozedropdown',
];

/**
 * Links ItemTags to learnosity player
 * */
class LearnosityItemTags extends PureComponent {
  static displayName = 'LearnosityItemTags';

  static propTypes = {
    /**
     * Questions list
     * */
    questions: PropTypes.array.isRequired,
    itemId: PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);

    this.itemLoad = this.itemLoad.bind(this);

    const { playerContainerId } = props;
    this.playerContainer = document.querySelector(`#${playerContainerId}`);
  }

  state = {
    itemId: 0,
    itemReference: '',
    correctMcqAnswers: [],
  };

  componentDidMount() {
    const {
      learnosityData: { app },
    } = this.props;
    app.on('item:load', this.itemLoad);
    /**
     * Sometimes the item:load event is not emitted, to ensure we call the callback and
     * this prevented the sidepanel with tags to not show.
     *
     * To avoid this situation we also listen for when a batch of items are loaded. Since
     * we only listen to this event once, we risk calling the callback twice only once.
     */
    app.once('items:lazyload:batch', this.itemLoad);
  }

  componentWillUnmount() {
    const {
      learnosityData: { app },
    } = this.props;
    if (app) {
      app.off('item:load', this.itemLoad);
    }
  }

  /**
   * Event handler for when item has loaded
   * */
  itemLoad = () => {
    const {
      questions,
      learnosityData: { app },
    } = this.props;
    const { reference, questions: learnosityQuestions } = app.getCurrentItem();
    const { itemId } = questions.find(
      ({ learnosityItemReference }) => learnosityItemReference === reference,
    ) || { itemId: this.props.itemId };
    // fallback to an unknown. This is more of a signal to help debugging than an actual type we manage.
    const itemType = learnosityQuestions[0].type || 'unknown';
    const mcqItem = learnosityQuestions.find(
      ({ type }) => VALID_ITEM_TYPES.indexOf(type) >= 0,
    );
    let correctMcqAnswers;
    try {
      correctMcqAnswers = mcqItem.validation.valid_response.value;
    } catch (error) {
      correctMcqAnswers = [];
    }

    this.setState({
      itemId,
      itemReference: reference,
      itemType,
      /**
       * Only one mcq question has to exist in the item
       * */
      correctMcqAnswers,
    });
  };

  render() {
    const { itemId, correctMcqAnswers, itemReference, itemType } = this.state;
    const { questionDetailsToogleRationale } = this.props;

    if (!itemId) {
      return null;
    }

    return React.cloneElement(this.props.children, {
      itemId,
      correctMcqAnswers,
      itemReference,
      itemType,
      questionDetailsToogleRationale,
    });
  }
}

export default LearnosityItemTags;
